import { FC } from 'react';
import { Skeleton } from '@components/ui/skeleton';

/**
 * Placeholder row shown while the default/Recommended or typed results are
 * loading, matching KnowledgeSearchRow's layout so the list doesn't jump in
 * height once real rows arrive.
 */
const KnowledgeSearchSkeletonRow: FC = () => (
  <div className="flex items-center gap-4 border-b border-border px-4 py-4 last:border-b-0">
    <div className="min-w-0 flex-1 space-y-2">
      <Skeleton className="h-3 w-16" />
      <Skeleton className="h-4 w-40" />
      <Skeleton className="h-3 w-56" />
    </div>
    <Skeleton className="size-5 shrink-0 rounded-full" />
  </div>
);

export default KnowledgeSearchSkeletonRow;
